import React from "react";
import { NavLink } from "react-router-dom";

class Navigation extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript("./assets/js/masonary.js");
  }

  render() {
    return (
      <>
        <div
          className={
            this.props.bgcolor !== ""
              ? `header-nav navbar-collapse collapse ${this.props.bgcolor}`
              : "header-nav navbar-collapse collapse"
          }
        >
          <ul className="nav navbar-nav d-flex flex-row">
            <li>
              <NavLink to={"/"} className={"text-decoration-none"}>
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to={"/about"} className={"text-decoration-none"}>
                About us
              </NavLink>
            </li>
            <li>
              <NavLink to={"/company"} className={"text-decoration-none"}>
                Company
              </NavLink>
            </li>
            <li className="active">
              <NavLink className={"text-decoration-none"}>Services</NavLink>
              <ul className="sub-menu">
                <li>
                  <NavLink
                    to={"/services?id=ecommerce"}
                    className={"text-decoration-none"}
                  >
                    E-commerce
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={"/services?id=labour"}
                    className={"text-decoration-none"}
                  >
                    Labour Service
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={"/services?id=apartments"}
                    className={"text-decoration-none"}
                  >
                    Apartment Handling
                  </NavLink>
                </li>
              </ul>
            </li>
            <li>
              <NavLink to={"/contact"} className={"text-decoration-none"}>
                Contact us
              </NavLink>
            </li>
          </ul>
        </div>
      </>
    );
  }
}

export default Navigation;
